<template>
    <div class="stats-col">
        <div v-for="item in items" :key="item.label" class="stat-item">
            <div class="stat-icon">
                <v-icon size="16">{{ item.icon }}</v-icon>
            </div>
            <div class="stat-content">
                <div class="stat-val">{{ item.value }}</div>
                <div class="stat-lbl">{{ item.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "StudentStatistics",
    props: {
        docs: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            routinesWeekly: 0,
            routinesMonthly: 0,
            averageTime: 0,
        }
    },
    computed: {
        items(vm = this) {
            return [
                { icon: 'mdi-calendar-month-outline', value: vm.routinesMonthly, label: vm.$t('student.routinesMonthly') },
                { icon: 'mdi-lightning-bolt-outline', value: vm.routinesWeekly, label: vm.$t('student.routinesWeekly') },
                { icon: 'mdi-timer-outline', value: `${vm.averageTime}'`, label: vm.$t('student.averageTime') },
            ]
        }
    },
    async mounted() {
        const vm = this
        await vm.loadStatistics()
    },
    methods: {
        async loadStatistics() {
            const vm = this
            vm.routinesMonthly = vm.docs.length || 0
            vm.averageTime = 0
            let hours = 0
            let datesRoutineInMonth = []
            vm.docs.forEach(doc => {
                datesRoutineInMonth.push(vm.$moment(doc.rawDate.full).format('DD-MM-YYYY'))
                hours += Number(doc.advance?.postInfo?.duration || 0)
            })
            hours = Number(hours / 60).toFixed(2).replace('.00', '')
            vm.averageTime = Number(hours / vm.routinesMonthly).toFixed(2).replace('NaN', '0').replace('.00', '')

            let startOfWeek = vm.$moment().startOf('week');
            let datesOfWeek = [startOfWeek.format('DD-MM-YYYY')]
            for (let i = 1; i <= 6; i++) datesOfWeek.push(startOfWeek.add(1, 'days').format('DD-MM-YYYY'))
            vm.routinesWeekly = datesOfWeek.filter(val => datesRoutineInMonth.includes(val)).length || 0
        }
    },
    watch: {
        docs() {
            this.loadStatistics()
        }
    }
}
</script>

<style scoped>
.stats-col {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 12px 14px;
}

.stat-icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--v-surface2-base);
}

.stat-icon .v-icon {
    color: var(--v-accent-base);
}

.theme--dark .stat-icon .v-icon {
    color: var(--v-primary-base);
}

.stat-content {
    min-width: 0;
}

.stat-val {
    font-size: 20px;
    font-weight: 800;
    line-height: 1;
    color: var(--v-txtPrimary-base);
}

.stat-lbl {
    margin-top: 2px;
    font-size: 11px;
    color: var(--v-txtMuted-base);
}
</style>
